import { render, staticRenderFns } from "./cleaningprices.vue?vue&type=template&id=a159ac4a&"
import script from "./cleaningprices.vue?vue&type=script&lang=js&"
export * from "./cleaningprices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a159ac4a')) {
      api.createRecord('a159ac4a', component.options)
    } else {
      api.reload('a159ac4a', component.options)
    }
    module.hot.accept("./cleaningprices.vue?vue&type=template&id=a159ac4a&", function () {
      api.rerender('a159ac4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25xTK9ImJYlbc/JS/cleaningprices.vue"
export default component.exports